<template>
  <div>
    <ContentPage headerText="About Us">
      <p>
        Welcome to Snetterton Auto Services, your trusted destination for
        reliable MOT testing, vehicle servicing, and repairs in South Norfolk.
        We take pride in delivering top-notch solutions to keep your vehicle
        safe, efficient, and roadworthy.
      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="sections">
          <div>
            <h2>
              Our Commitment to Quality
            </h2>

            <p>
              At Snetterton Auto&rsquo;s, we are committed to excellence in
              every aspect of our work. Our mission is to provide you with a
              hassle-free experience, ensuring your vehicle meets all necessary
              safety standards. With a focus on precision and attention to
              detail, our team of experienced technicians uses state-of-the-art
              equipment and the latest diagnostic tools to deliver thorough MOT
              tests and comprehensive servicing.
            </p>
          </div>

          <div>
            <h2>Why Choose Us?</h2>
            <ul class="list">
              <li>
                <strong>Experienced Professionals:</strong> Our team consists of
                skilled and certified technicians with years of hands-on
                experience in the automotive industry. You can trust us to
                handle your vehicle with the utmost care and expertise.
              </li>
              <li>
                <strong>Comprehensive Services:</strong> testing to routine
                servicing and repairs, we offer a wide range of services to
                address all your vehicle's needs under one roof.
              </li>
              <li>
                <strong>Modern Facilities:</strong> Equipped with advanced
                technology and tools, our workshop is designed to handle
                vehicles of all makes and models, ensuring accurate diagnostics
                and efficient repairs
              </li>
              <li>
                <strong>Customer Satisfaction:</strong> Your satisfaction is our
                priority. We believe in transparent communication, fair pricing,
                and personalized service tailored to meet your specific
                requirements.
              </li>
            </ul>
          </div>

          <div>
            <h2>Meet our Team</h2>

            <div class="row card-container">
              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/steven.jpg"
                    alt="Steven Jackson wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Steven Jackson</h5>
                    <p class="card-subtitle mb-2">Director</p>
                    <p class="card-text">
                      Steven has years of experience in the automotive industry
                      and brings a wealth of knowledge and expertise to our
                      team. Steven handles the day to day running of the
                      workshop and will be in the office to greet you with a big
                      smile.
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/reece.jpg"
                    alt="Reece wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Reece</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Reece is our hardworking apprentice at Snetterton Auto Services, eager to learn and grow within the automotive industry. He brings enthusiasm and a positive attitude to every task, always keen to develop new skills. Under the guidance of the team, Reece has quickly become a valuable part of the workshop.
                    </p>
                  </div>
                </div>
              </div>
            

              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/hanna.jpg"
                    alt="Hanna wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Hanna</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Hanna is our welcoming voice and organised mind behind our front desk. Hanna plays a key role in making sure customers receive a smooth and hassle-free experience, from arranging bookings to keeping everyone updated throughout their visit. Her friendly attitude, attention to detail, and commitment to great customer service help keep the garage running efficiently every day.
                    </p>
                  </div>
                </div>
              </div>
            
              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/warren.jpg"
                    alt="Warren wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Warren</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Warren is a highly experienced and reliable member of the Snetterton Auto Services team, known for his strong work ethic and attention to detail. He approaches each task with professionalism and a commitment to excellence. Whether tackling diagnostics or complex repairs, Warren ensures every job is done right the first time.
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/georgia.jpg"
                    alt="Georgia wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Georgia</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Georgia is the friendly and efficient face of the Snetterton Auto Services reception, keeping everything running smoothly behind the scenes. She handles bookings, enquiries, and customer support with professionalism and a smile. Always ready to help, Georgia ensures every customer has a great experience from start to finish.
                    </p>
                  </div>
                </div>
              </div>

              <div class="mb-4 col-sm-6 mb-sm-0 col-lg-4">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="/images/team/danny.jpg"
                    alt="Danny wearing company jacket"
                  />

                  <div class="card-body">
                    <h5 class="card-title">Danny</h5>
                    <p class="card-subtitle mb-2"></p>
                    <p class="card-text">
                      Danny is a highly skilled technician at Snetterton Auto Services with over 10 years of hands-on experience in vehicle diagnostics, MOT testing and repairs. Known for his precision, he’s committed to getting customers back on the road safely and efficiently. Whether it’s routine maintenance, MOT testing or complex engine work, Danny delivers reliable results every time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <h2>Visit Us Today</h2>
            <p>
              We invite you to experience the difference at Snetterton Auto’s.
              Visit our
              <a
                href="https://maps.app.goo.gl/nUtjdSjMGmo9aCZJ8"
                target="_blank"
                rel="noopener noreferrer"
                class="underline"
                >conveniently located workshop</a
              >
              just a stone throw away from Snetterton Race Track, and let us
              take care of all your MOT testing and servicing needs. Your safety
              and satisfaction are our top priorities, and we look forward to
              serving you.
            </p>
            <p>
              <router-link to="/contact-us/" class="underline">
                Contact Us</router-link
              >
              to book an appointment or learn more about our services.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPage from '@/components/partials/ContentPage.vue'

export default {
  name: 'about-us',
  components: {
    ContentPage
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";

.content {
  padding-top: 64px;
  padding-bottom: 64px;
}

.card-container {
  row-gap: 30px;
}

.card {
  height: 100%;

  border: 0;
  background-color: #f5f5f5;
  box-shadow: $shadow;

  &-body {
    border-right: 20px solid $clr-theme-red;
  }

  &-title {
    color: $clr-theme-red;
    font-weight: 700;
  }

  &-subtitle {
    font-size: 18px;
  }

  &-text {
    font-weight: 400;
    text-align: justify;
  }

  &-img-top {
    height: 300px;
    object-fit: cover;
  }
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 5rem;

  > * {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
}

.list {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  font-weight: 500;

  strong {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AboutUs.vue